export default class ContributorTypeDto {
    constructor(object) {
        this.id = object.code
        this.code = object.code
        this.name = object.name
    }
}